$(document).on('click', '.js-copy', function H(e) {
    /* Get the text field */
    let copyText = document.getElementById("urlField");
    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    /* Copy the text inside the text field */
    navigator.clipboard.writeText(copyText.value);

    $(this).addClass('active');
});
